/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-shadow */
import React from 'react';
import { format, isValid, parse } from 'date-fns';
import {
  AreaChart, Area, XAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import styles from './CompanyDataV2.module.css';
import useSorting from '../../../components/CommonFunction/useSorting';
import { getMonthInfo, renderNumber } from '../../../utilities/general';

const AreaChartNew = (props) => {
  const { days, chartData, chartId } = props;

  const { items } = useSorting(chartData, 'date', 'descending');

  // Get the baseline (first value)
  const baselineValue = items[0]?.value;

  const data = items?.map((item, index) => ({
    date: item.date,
    originalValue: item.value,
    value: index === 0 ? 0 : item.value - baselineValue,
  }));

  const DateFormatter = (date) => {
    const d = days === 180 ? parse(date, 'M yyyy', new Date()) : parse(date, 'yyyy-MM-dd', new Date());
    return isValid(d) ? days === 'Last 3 Months' ? format(d, 'LLL') : format(d, 'LLL dd') : null;
  };

  const CustomTooltip = (propss) => {
    const { payload } = propss;
    const assetValue = payload?.map((val) => val?.payload);
    return (
      <div className="flex p-3 h-18 w-30 bg-white rounded-xl shadow-xl border border-gray-400">
        {
          assetValue?.map((item, i) => {
            const {
              day, daySuffix, month, year,
            } = getMonthInfo(item?.date);
            return (
              <div className="flex flex-col gap-1" key={i}>
                <div className="text-base text-[#58667E] font-normal">
                  <span>{day}</span>
                  <sup>{daySuffix}</sup>
                  <span>{` ${month}, ${year}`}</span>
                </div>
                <div className={`flex ${item?.value > 0 ? 'text-[#4ECA2C]' : 'text-[#ED2D27]'} text-base font-normal justify-center`}>{`$${renderNumber(item?.originalValue)}`}</div>
              </div>
            );
          })
        }
      </div>
    );
  };

  const CustomDot = (propss) => {
    const {
      cx, cy, payload,
    } = propss;
    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        stroke="white"
        strokeWidth={1.6}
        fill={payload?.value >= 0 ? 'green' : 'red'}
      />
    );
  };

  const gradientOffset = () => {
    const dataMax = Math.max(...data.map((i) => i?.value));
    const dataMin = Math.min(...data.map((i) => i?.value));
    if (dataMax <= 0) {
      return 0;
    }
    if (dataMin >= 0) {
      return 1;
    }
    return dataMax / (dataMax - dataMin);
  };

  const off = gradientOffset();
  return (
    <div className={`${styles.paddingLeft19} flex flex-col py-2 px-2 h-full`}>
      <div className="w-full h-full">
        <ResponsiveContainer width="100%" height="99.59%">
          <AreaChart
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 20,
            }}
          >
            <defs>
              <linearGradient id={chartId} x1={off === 1 || off === 0 ? '1' : '0'} y1="0" x2="0" y2="1">
                <stop offset={off} stopColor="green" stopOpacity={1} />
                <stop offset={off} stopColor="red" stopOpacity={1} />
              </linearGradient>
            </defs>
            <defs>
              <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#4ECA2C" stopOpacity={0.8} />
                <stop offset={off} stopColor="#4ECA2C" stopOpacity={0.1} />
                <stop offset={off} stopColor="#EF494D" stopOpacity={0.1} />
                <stop offset="100%" stopColor="#EF494D" stopOpacity={0.8} />
              </linearGradient>
            </defs>
            <Tooltip
              cursor={false}
              content={<CustomTooltip />}
            />
            <XAxis
              dataKey="date"
              tickLine={false}
              tickFormatter={DateFormatter}
              tickSize={12}
              interval={days === '30 Days' ? 5 : 'preserveStartEnd'}
              style={{ fontSize: 10 }}
              axisLine={false}
              stroke="#A3AED0"
              // padding={{ left: 15, right: 3 }}
            />
            {/* <ReferenceLine y={0} stroke="#C6D5DD" strokeWidth={2.5} /> */}
            <Area
              type="monotone"
              dataKey="value"
              stroke={`url(#${chartId})`}
              strokeWidth={2}
              fill="url(#splitColor)"
              activeDot={<CustomDot />}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AreaChartNew;
